import { Icon, type IconName } from '@latitude/icons';
import { Spinner } from '@latitude/spinner';
import type { VariantProps } from 'class-variance-authority';
import type { toastVariants } from 'variants/toast-variants';

/**
 * Renders an icon based on the provided variant.
 *
 * @param variant - The variant of the toast.
 * @returns The rendered icon component.
 */
export const ToastIcon = ({ variant }: VariantProps<typeof toastVariants>) => {
  if (variant === 'loading') {
    return <Spinner size="medium" />;
  }

  let name: IconName;

  switch (variant) {
    case 'success':
      name = 'check-circle';
      break;
    case 'warning':
      name = 'alert-triangle';
      break;
    case 'danger':
      name = 'alert-circle';
      break;
    case 'alert':
      name = 'alert-octagon';
      break;

    default:
      name = 'info-circle';
      break;
  }
  return <Icon name={name} className="size-6 shrink-0" />;
};
